import { ChefHatIcon } from './ChefHatIcon';

/**
 * author: Simran
 * id E22BD22B-9748-4CA8-A748-B5598B08A7DE
 * name chef-hat
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chef-hat.svg
 * tags
 * - Clothing 
 */
export const ToqueIcon = ChefHatIcon;
export default ToqueIcon